import React, { useState, CSSProperties, useEffect } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { DarwinInput } from '../Input';
import { useDebounce } from '@uidotdev/usehooks';
import styles from './SearchBox.module.css';

export interface SearchBoxProps {
  onSearch?: (query: string) => void;
  placeholder?: string;
  style?: CSSProperties;
  className?: string;
}

export const SearchBox = ({
  onSearch,
  placeholder,
  style,
  className,
}: SearchBoxProps) => {
  const [keyword, setKeyword] = useState('');

  const debouncedKeyword = useDebounce(keyword, 300);

  useEffect(() => {
    onSearch?.(debouncedKeyword);
  }, [debouncedKeyword, onSearch]);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setKeyword(e.target.value);
  };

  return (
    <DarwinInput
      type="text"
      style={style}
      prefix={<SearchOutlined className={styles.searchBox} />}
      placeholder={placeholder}
      value={keyword}
      onChange={handleSearch}
      className={className}
    />
  );
};
